export enum ThemeName {
  DarkTheme = "DarkTheme",
  LightTheme = "LightTheme",
}
